import { createContext } from 'react';

// Embedded apps render their controls into the shared header without moving app state.
export default createContext(null);
